/** Cookie the `@flint/ui` Sidebar primitive writes on every toggle. */
const SIDEBAR_COOKIE_NAME = "sidebar_state";

/**
 * Read the persisted sidebar open/closed state for `SidebarProvider.defaultOpen`.
 *
 * The primitive *writes* this cookie but never reads it back, so the caller has
 * to seed `defaultOpen` — that's the upstream shadcn contract, not a workaround.
 * It matters twice over here: `StoreAdminLayout` remounts with the outlet on
 * every navigation, so without a read-on-init the rail would spring back open
 * on each page change as well as on reload.
 *
 * Must be called during render (as the `defaultOpen` argument), not in an
 * effect — an effect would run after first paint and flash the wrong width.
 *
 * Defaults to open when there's no cookie, when storage is unreadable, or
 * during SSR.
 */
export function readSidebarCookie(): boolean {
  if (typeof document === "undefined") return true;
  try {
    const match = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${SIDEBAR_COOKIE_NAME}=`));
    if (!match) return true;
    return match.slice(SIDEBAR_COOKIE_NAME.length + 1) !== "false";
  } catch {
    // Cookies can throw in sandboxed iframes / locked-down browsers.
    return true;
  }
}
